import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "jobNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.JOB.fullString,
    hasInputLabel: true,
  },
  { apiName: "jobTrackingEnabled", component: "FrmCheckbox" },
];
